
import { defineComponent, Ref, ref, onMounted, inject } from "vue";
import { apiService } from "@services/api.service";
import PortfolioTile from "@components/portfolios/tile.vue";
import UserProfileSlider from "./slider.vue";

export default defineComponent({
  name: "CiUsersProfilePortfolios",
  components: {
    "ci-portfolio-tile": PortfolioTile,
    "ci-user-profile-slider": UserProfileSlider,
  },
  inject: {
    slug: "userSlug",
  },
  props: {
    owner: {
      type: Boolean,
      default: false,
    },
  },
  setup() {
    const portfolios: Ref<Portfolios.TileData[]> = ref([]);
    const slug = inject("userSlug", "");
    const loading = ref(true);

    const loadUserPortfolios = async () => {
      try {
        const response = await apiService.users.getUserPortfolios(slug);
        portfolios.value = response.data.portfolios;
      } catch (err) {
        apiService.handleAPIError(err);
        portfolios.value = [];
      } finally {
        loading.value = false;
      }
    };

    onMounted(loadUserPortfolios);

    return {
      portfolios,
      loading,
    };
  },
});
